import _get from 'lodash/get';
import {GROUP_HOME_APP_DEFINITION_ID} from 'groups-env';
import {GROUP_SLUG_PATTERN} from '../constants';

const parseConfig = c => {
  try {
    return typeof c === 'string' ? JSON.parse(c) : c;
  } catch (e) {
    return c;
  }
};

export default ({appRouters, routerReturnedData, _self, location, eventEmitter}) => {
  //console.log({routerReturnedData});
  const wixLocation = location;
  const noop = () => {};

  function getMenuRoutes() {
    const config = parseConfig(appRouters[0].config);

    return Promise.resolve(Object.keys(config.patterns).map(pattern => {
      const {title, appData: {appDefinitionId, appPageId}} = config.patterns[pattern];
      return {title, appDefinitionId, appPageId, page: pattern.split('/')[2]};
    }));
  }

  function matchRoute({appDefinitionId, sectionId, onSuccess = noop, onError = noop}) {
    if (!appDefinitionId || !sectionId) {
      onError('Error: please provide app ID and section ID for navigation');
    }
    let foundRoute = false;
    appRouters.forEach(router => {
      if (foundRoute) {
        return;
      }
      const config = parseConfig(router.config);
      return config.patterns && Object.keys(config.patterns).forEach(pattern => {
        if (foundRoute) {
          return;
        }
        const item = config.patterns[pattern];
        if (item.appData && item.appData.appDefinitionId === appDefinitionId && item.appData.appPageId === sectionId) {
          foundRoute = true;
          onSuccess(router.prefix, pattern);
        }
      });
    });

        // look in site pages, not member app routes
    if (!foundRoute) {
      const sitePages = _self.wix.site.getSiteStructure().pages;
      const pages = sitePages || [];
      const page = pages.filter(pg => pg.applicationId === appDefinitionId && !pg.prefix).pop();

      if (page) {
        foundRoute = true;
        return onSuccess('', page.url);
      }

      return onError(`Error: can not resolve route for app ${appDefinitionId} and page ${sectionId}`);
    }
  }

  return {
    hasSocialPages: (onSuccess, onError) => {
      return new Promise((resolve, reject) => {
        if (!appRouters) {
          if (onError) {
            onError('App routers not initialised');
          }
          return reject('App routers not initialised');
        }

        const socialPages = appRouters.filter(router => {
          const routerConfig = router.config;
          return routerConfig.type === 'public' && routerConfig.patterns && Object.keys(routerConfig.patterns).length > 0;
        });
        if (onSuccess) {
          onSuccess(socialPages.length > 0);
        }
        resolve(socialPages.length > 0);
      });
    },
    getViewedUser: (onSuccess, onError) => {
      return new Promise((resolve, reject) => {
        const viewedUser = _get(routerReturnedData, 'memberData.memberContactId');
        if (viewedUser) {
          if (onSuccess) {
            onSuccess(viewedUser);
          }
          resolve(viewedUser);
        } else {
          if (onError) {
            onError('Error getting viewed user');
          }
          reject('Error getting viewed user');
        }
      });
    },
    navigateToSection: ({appDefinitionId, sectionId, tpaInnerRoute = '', groupId = ''}, onError) => {
      return new Promise((resolve, reject) => {
        matchRoute({appDefinitionId, sectionId, onSuccess: (prefix, suffix) => {
          if (prefix && prefix.indexOf('/') !== 0) {
            prefix = `/${prefix}`;
          }

          if (tpaInnerRoute && tpaInnerRoute.charAt(0) !== '/') {
            tpaInnerRoute = '/' + tpaInnerRoute;
          }

          wixLocation.to(`${prefix}${groupId ? suffix.replace(GROUP_SLUG_PATTERN, groupId) : suffix}${tpaInnerRoute}`);
          resolve();
        }, onError: reason => {
          if (onError) {
            onError(reason);
          }
          reject(reason);
        }});
      });
    },
    getSectionUrl: ({appDefinitionId, sectionId, groupId = ''}, callBack) => {
      return new Promise((resolve, reject) => {
        matchRoute({appDefinitionId, sectionId, onSuccess: (prefix, suffix) => {
          if (prefix && prefix.indexOf('/') !== 0) {
            prefix = `/${prefix}`;
          }
          const queryParams = Object.keys(wixLocation.query).map(key => {
            return `${key}=${wixLocation.query[key]}`;
          }).join('&');
          if (callBack) {
            callBack(`${wixLocation.baseUrl}${prefix}${groupId ? suffix.replace(GROUP_SLUG_PATTERN, groupId) : suffix}${queryParams ? '?' + queryParams : ''}`);
          }
          resolve(`${wixLocation.baseUrl}${prefix}${groupId ? suffix.replace(GROUP_SLUG_PATTERN, groupId) : suffix}${queryParams ? '?' + queryParams : ''}`);
        }, onError: () => {
          console.error('Route not found for app', appDefinitionId, 'and section', sectionId);
          if (callBack) {
            callBack(wixLocation.url);
          }
          reject(wixLocation.url);
        }});
      });
    },

    getMenuRoutes,

    navigateToGroup: ({groupId}) => {
      const [router] = appRouters;
      return Promise.resolve(wixLocation.to(`/${router.prefix}/${groupId}/forum`));
    },

    getCurrentGroupLink: groupSlug => {
      return getMenuRoutes().then(routes => {
        const groupHomePage = routes.find(({appDefinitionId}) => appDefinitionId === GROUP_HOME_APP_DEFINITION_ID).page;
        const [router] = appRouters;
        return `${location.baseUrl}/${router.prefix}/${groupSlug || location.path[0]}/${groupHomePage}`;
      });
    },

    registerEventListener: (eventName, listener, listenerName) => {
      const cb = event => listener(event);
      cb.listenerName = listenerName;
      console.log('[groups]registerEventListener', {eventName, listener, listenerName});
      eventEmitter && eventEmitter.on(eventName, cb);
    },

    removeEventListener: (eventName, listenerName) => {
      console.log('[groups]removeEventListener', {eventName, listenerName});
      eventEmitter && eventEmitter.removeListener(eventName, listenerName);
    },

    publishEvent: (eventName, data) => {
      eventEmitter && eventEmitter.emit(eventName, data);
    }
  };
};
